const Modal = ({ onHide = () => null, show, children }) => {
  return show ? (
    <>
      <div className="modal" onClick={onHide}></div>
      <div className="modal-content">{children}</div>
    </>
  ) : (
    <></>
  );
};

export default Modal;
